export default "__VITE_PUBLIC_ASSET__54aad84d__"